import React, { useState } from 'react'
import { Accordion, Button } from "react-bootstrap";
import {
    Table as TableComponent,
    TotalesPago,
} from "../../../Components";
import * as QLIBS from '../../../qLibsHelpers';
import { DEFAULT_HEADER } from '../../../Config/userToken';
import { APPCONFIG } from '../../../app.config';
import { formatDate } from '../../../utils/dateHelpers';
import { truncate } from '../../../Shared/Utils';
import { GLOBAL } from '../../../Config/global';
const { PRODUCERURL } = APPCONFIG.ENDPOINTS;
const { REPORT_FORMAT } = GLOBAL;
const SectionEnum = {
    DetallePago: 1,
};

const initSections = [
    {
        id: SectionEnum.DetallePago,
        title: 'Detalle de pago',
        loaded: false,
    },
];

const columnsDef = {
    [SectionEnum.DetallePago]: {
        "fecha": { title: "Fecha Liquidación", format: REPORT_FORMAT.FECHA, field: 'Fecha' },
        "devengo": { title: "Concepto", field: 'Devengo' },
        "montoNeto": { title: "Monto Bruto", format: REPORT_FORMAT.MONEDA, field: 'MontoNeto' },
        "iva": { title: "Iva 21%", format: REPORT_FORMAT.MONEDA, field: 'IVA' },
        "percepcion": { title: "Iva 3%", format: REPORT_FORMAT.MONEDA, field: 'Percepcion' },
        "totalBR": { title: "Comisión Total", signo: '$', format: REPORT_FORMAT.MONEDA, field: 'TotalBR' },
    },
};

const apiMethods = {
    [SectionEnum.DetallePago]: (props) => `DetallePago?pagoNro=${props.original.numero}`,
};

const buildColumns = (sectionId) => {
    return QLIBS.getTableColumns(columnsDef[sectionId]).map((column) => {
        if (column.format === REPORT_FORMAT.MONEDA) {
            return {
                ...column,
                Cell: ({ value }) => {
                    if (value === null || value === undefined || value === '') return '';

                    const numericValue = Number(value);
                    if (Number.isNaN(numericValue)) return value;

                    return (
                        <div style={{ marginLeft: 'auto' }}>
                            {`$ ${truncate(numericValue, 2)}`}
                        </div>
                    );
                },
                style: {
                    ...(column.style || {}),
                    textAlign: 'right'
                },
                headerStyle: {
                    ...(column.headerStyle || {}),
                    textAlign: 'right'
                }
            };
        }

        if (column.format === REPORT_FORMAT.FECHA) {
            return {
                ...column,
                Cell: ({ value }) => value ? formatDate(value, 'dd/MM/yyyy') : ' '
            };
        }

        return column;
    });
};

class PolicyDetailGrid extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            columns: buildColumns(props.id),
            details: [],
            loadingTable: false,
            width: (props.width === undefined || props.width === null) ? '100%' : props.width.toString() + 'px'

        };
        this.pageSize = 10;
        this.page = 0;
        this.pages = 0;
    }

    createExcelReportColumns() {
        const excelReportColumns = this.state.columns.filter(f => f.show).map(c => {
            return {
                Title: c.title,
                Field: c.field,
                Summarize: c.summarize,
                Format: c.format
            }
        });
        return excelReportColumns;
    }

    handleSubmit = () => {
        const requestOptions = {
            method: 'GET',
            headers: DEFAULT_HEADER.get(),
        };

        this.setState({ loadingTable: true });
        let parseUrl = `${PRODUCERURL}api/Settlement/${apiMethods[this.props.id](this.props)}`;

        if (this.state.sort) {
            const params = {
                desc: this.state.sort[0].desc,
                sort: this.state.sort[0].id,
            };
            const queryString = Object.keys(params)
                .map((key) => key + '=' + params[key])
                .join('&');
            parseUrl += `&${queryString}`
        }

        fetch(parseUrl, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                this.pages = Math.ceil(data.data.length / this.pageSize);
                this.setState({ details: data, loadingTable: false });
            });
    }
    getFileName = (id) => {
        for (let seccion in SectionEnum) {
            if (SectionEnum[seccion] === id) {
                return `${seccion}.xlsx`;
            }
        }
        return `Documento.xlsx`;
    }

    handleExport = () => {
        const requestOptions = {
            method: 'POST',
            headers: DEFAULT_HEADER.get(),
            body: JSON.stringify({ payment: this.props.original.numero, columns: JSON.stringify(this.createExcelReportColumns()) })
        };

        this.setState({ loadingTable: true });
        let parseUrl = `${PRODUCERURL}api/Settlement/DetallePagoLiquidacion/Export?tipoPagoLiq=2`;
        let nombre = this.getFileName(this.props.id);
        fetch(parseUrl, requestOptions)
            .then((response) => {
                if (response.ok)
                    return response.blob();
            })
            .then(function (blob) {
                if (blob) {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = nombre;
                    link.click();
                }
            })
            .then(() => {
                this.setState({ loadingTable: false });
            });
    }

    componentDidMount() {
        this.handleSubmit()
    }

    applyFilter = (event) => {
        if (event.length > 0) {
            this.page = 0
            this.setState({
                filters: event,
            }, this.handleSubmit);
        }
        else {
            this.setState({
                filters: [],
            }, this.handleSubmit);
        }
    }
    getFilter() {
        let filters = this.state.filters
        return filters
    }
    getSort() {
        let sort = this.state.sort
        return sort
    }
    applySort = (event) => {
        if (event.length > 0) {
            this.setState({
                sort: event,
            }, () => this.handleSubmit());
        }
        else {
            this.setState({
                sort: {},
            },
                this.handleSubmit);
        }
    }
    changeSize = async (size) => {
        this.pageSize = size;
        this.handleSubmit()
    }
    changePage = async (page) => {
        this.page = page;
        this.handleSubmit()
    }

    render() {
        return (
            <div style={{
                width: '100%',
                maxWidth: '100vw',
                overflow: 'hidden'
            }}>
                <div style={{ display: 'flex', justifyContent: 'end' }}>
                    <button type="submit"
                        className='btn btn-primary text-white m-2'
                        onClick={this.handleExport}
                        size="small">
                        <i className="bi bi-arrow-down-circle-fill" /> Descargar</button>
                </div>
                <div style={{
                    width: '100%',
                    overflowX: 'auto',
                    overflowY: 'visible'
                }}>
                    <TableComponent
                        loading={this.state.loadingTable}
                        columns={this.state.columns}
                        data={this.state.details.data}
                        manual={false}
                        onSortedChange={this.applySort}
                        expandable={this.props.expandable}
                        subComponent={props => {
                            const propsJoin = Object.assign({}, { ...this.props }, { ...props }, { original: Object.assign({}, { ...this.props.original }, { ...props.original }) })
                            return (<PagoLiquidacionesDrillDown secondLevel={this.props.expandable} {...propsJoin} />)
                        }} />
                    <TotalesPago items={this.state.details} />
                </div>
            </div>
        );
    }
}



const PagoLiquidacionesDrillDown = (props) => {
    const filteredSections = initSections.filter(e => e.secondLevel === props.secondLevel)

    const [sections, setSections] = useState(JSON.parse(JSON.stringify(filteredSections)));

    const loadSection = (id) => {
        const section = sections.find(e => e.id === id);

        if (section.loaded) return;

        const expandable = section.expandable && !props.secondLevel

        section.loaded = true;
        section.grid = <PolicyDetailGrid  {...props} id={id} expandable={expandable} />;

        setSections(sections.slice());
    };

    const handleAccordionToggle = (eventKey) => {
        if (eventKey) {
            loadSection(parseInt(eventKey));
        }
    };

    return (
        <div style={{ width: '100%', maxWidth: '95vw' }}>
            <Accordion defaultActiveKey="0" onSelect={handleAccordionToggle}>
                {sections.map(e => (
                    <Accordion.Item key={e.id} eventKey={e.id}>
                        <Accordion.Header>
                            {e.title}
                        </Accordion.Header>
                        <Accordion.Body style={{ padding: '0' }}>
                            {e.grid}
                        </Accordion.Body>
                    </Accordion.Item>
                ))}
            </Accordion>
        </div>

    );
};

export default PagoLiquidacionesDrillDown;
